export default [
  {
    path: "/engine/scan-engine",
    name: "scanEngine",
    component: () => import(
      /*webpackChunkName:'engine'*/
      "@/views/scanengine/ScanEngine.vue"),
    meta: {},
  },
  {
    path: "/engine/template/website",
    name: "NzTemplateList",
    component: () => import(
      /*webpackChunkName:'NzTemplateList'*/
      "@/views/template/NzTemplateList.vue"),
    meta: {},
  },
  {
    path: "/poc/exploitdb",
    name: "ExploitdbPocList",
    component: () => import(
      /*webpackChunkName:'ExploitdbPocList'*/
      "@/views/cvepoc/ExploitdbPocList.vue"),
    meta: {},
  },
   {
    path: "/poc/monitor",
    name: "MonitorList",
    component: () => import(
      /*webpackChunkName:'MonitorList'*/
      "@/views/cvepoc/MonitorList.vue"),
    meta: {},
  },
  {
    path: "/poc/cve-detect",
    name: "CveDetectList",
    component: () => import(
      /*webpackChunkName:'CveDetectList'*/
      "@/views/cvepoc/CveDetectList.vue"),
    meta: {},
  },
  {
    path: "/engine/dictionary",
    name: "EngineDictionary",
    component: () => import(
      /*webpackChunkName:'EngineDictionary'*/
      "@/views/scanengine/EngineDictionary.vue"),
    meta: {},
    
  },
]